import { Stack } from "@mui/material";
import { useMemo } from "react";

import { splitGqlUnion } from "~/shared/helpers/splitGqlUnion";

import { createFieldList, filterNullValues } from "./formHelpers";
import { Shared_FormTemplateFragment } from "./fragments/fragments.generated";
import QuestionAmountDisplay from "./questions/QuestionAmountDisplay";
import QuestionDateTimeDisplay from "./questions/QuestionDateTimeDisplay";
import QuestionTextDisplay from "./questions/QuestionTextDisplay";
import SelectableQuestionDisplay from "./questions/SelectableQuestionDisplay";
import { NarrowedFormField } from "./types";

type Props = {
    form: Shared_FormTemplateFragment;
    values: Record<string, string | null>;
};

export default function FormTemplateFormDisplay({ form, values }: Props) {
    const visibleFields = useMemo(() => createFieldList(form, values), [form, values]);
    const filteredValues = filterNullValues(values);

    return (
        <Stack gap={2}>
            {visibleFields.map(q =>
                splitGqlUnion(q.type, {
                    GqlSettingsFormTemplateQuestionTypeAmount: t => (
                        <QuestionAmountDisplay
                            key={q.id}
                            field={NarrowedFormField.create(q, t)}
                            value={filteredValues[q.key]}
                        />
                    ),
                    // TODO: implement recording field
                    GqlSettingsFormTemplateQuestionTypeRecording: () => null,
                    GqlSettingsFormTemplateQuestionTypeDropdown: t => (
                        <SelectableQuestionDisplay
                            key={q.id}
                            field={NarrowedFormField.create(q, t)}
                            value={filteredValues[q.key]}
                        />
                    ),
                    GqlSettingsFormTemplateQuestionTypeSelect: t => (
                        <SelectableQuestionDisplay
                            key={q.id}
                            field={NarrowedFormField.create(q, t)}
                            value={filteredValues[q.key]}
                        />
                    ),
                    GqlSettingsFormTemplateQuestionTypeText: t => (
                        <QuestionTextDisplay
                            key={q.id}
                            field={NarrowedFormField.create(q, t)}
                            value={filteredValues[q.key]}
                        />
                    ),
                    GqlSettingsFormTemplateQuestionTypeDateTime: t => (
                        <QuestionDateTimeDisplay
                            key={q.id}
                            field={NarrowedFormField.create(q, t)}
                            value={filteredValues[q.key]}
                        />
                    ),
                }),
            )}
        </Stack>
    );
}
